export enum ENUM_DATE_TIME_RANGE {
  currentDay,
  pastDay,
  currentMonth,
  pastMonth,
  all,
  custom,
}
